module.exports = require("@material-ui/core/Slide");